import { DEFAULT_CREATED_BY } from 'components/Inputs/CreatedBySelect/constants';
import { IQueryBrandData } from './types';

export const DEFAULT_BRAND_QUERY: IQueryBrandData = {
  createdByData: { id: DEFAULT_CREATED_BY, name: DEFAULT_CREATED_BY },
  limit: 100,
  isDeleted: { id: 'false', name: 'notDeleted' },
};
